import BannerData, { BannerType } from "@/domain/entities/BannerData";
import { BannerData as BannerDataSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const bannerDataMapper = (banner: BannerDataSDK): BannerData =>
    new BannerData({
        id: banner.id,
        icon: banner.icon,
        title: banner.title,
        mainText: banner.mainText,
        callToActionText: banner.callToActionText,
        callToActionCallback: banner.callToActionCallback,
        type: banner.type
            ? (banner.type as unknown as BannerType)
            : BannerType.INFO,
        dismissible: banner.dismissible,
        linkUrl: banner.linkUrl,
        priority: banner.priority,
    });

export default bannerDataMapper;
